export const arrayToChunks = (sourceArr, chunkSize) => {
  const chunksArray = [];
  for (let i = 0; i < sourceArr.length; i += chunkSize)
    chunksArray.push(sourceArr.slice(i, i + chunkSize));
  return chunksArray;
};
